<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="./">Home</a></li>
              <li class="breadcrumb-item active">User Profile</li>
            </ol>
          </div>
          <h4 class="page-title">User Profile</h4>
        </div>
      </div>
    </div>

    <!-- end page title -->
    <div class="row">
      <div class="col-12">
        <div class="card-box text-center">
          <h3>User Profile</h3>
          <p class="sub-header">
            Manage User Profile
          </p>
          <div class="header-icon-container"><i class="fe-user header-icon"></i></div>
          <div class="profile-text" *ngIf="!!currentUser">{{currentUser.email}}</div>
          <form class="col-lg-6 col-md-8 col-12 mx-auto mt-2 text-left" [formGroup]="userProfileForm" name="form" (ngSubmit)="save()" autocomplete="off">
            <div class="form-group col-md-8 mx-auto my-2">
              <label for="name">First Name</label>
              <input class="form-control" id="name" formControlName="name" required placeholder="">
              <ul *ngIf="isSubmitted || userProfileForm.controls.name.touched" class="parsley-errors-list filled">
                <li *ngIf="userProfileForm.controls.name.hasError('required')" class="parsley-required">First name is required</li>
              </ul>
            </div>
            <div class="form-group col-md-8 mx-auto my-2">
              <label for="lastName">Last Name</label>
              <input class="form-control" id="lastName" formControlName="lastName" required placeholder="">
              <ul *ngIf="isSubmitted || userProfileForm.controls.lastName.touched" class="parsley-errors-list filled">
                <li *ngIf="userProfileForm.controls.lastName.hasError('required')" class="parsley-required">Last name is required</li>
              </ul>
            </div>
            <div class="form-group col-md-8 mx-auto my-2">
              <label for="phoneNumber">Phone Number</label>
              <input class="form-control" id="phoneNumber" formControlName="phoneNumber" required placeholder="">
              <ul *ngIf="isSubmitted || userProfileForm.controls.phoneNumber.touched" class="parsley-errors-list filled">
                <li *ngIf="userProfileForm.controls.phoneNumber.hasError('required')" class="parsley-required">Phone number is required</li>
              </ul>
              <div class="col-md-2"></div>
            </div>


            <hr class="my-4" />
            <div class="col-md-8 mx-auto">
              <h5 class="mb-2">Two-Factor Authentication</h5>

              <p *ngIf="is2FAEnabled" class="text-success">Two-Factor Authentication is enabled.</p>

              <div *ngIf="!is2FAEnabled && !qrCodeSvg">
                <button class="btn btn-outline-primary" (click)="generate2FA()">Enable 2FA</button>
              </div>

              <div *ngIf="is2FAEnabled">
                <button class="btn btn-outline-danger" (click)="disable2FA()">Disable 2FA</button>
              </div>

              <div *ngIf="qrCodeSvg">
                <p>Scan this QR code with Microsoft Authenticator:</p>
                <div [innerHTML]="qrCodeSvg | safeHtml" class="mb-2"></div>
                <p>Manual Entry Code: <strong>{{ manualEntryKey }}</strong></p>

                <div class="form-group">
                  <label for="otp">Enter 6-digit code</label>
                  <input formControlName="otpCode" name="otpCode" id="otp" maxlength="6" class="form-control" />
                </div>

                <button class="btn btn-success mt-2" (click)="verifyAndEnable2FA()">Verify & Enable</button>

                <div *ngIf="twoFAError" class="text-danger mt-2">{{ twoFAError }}</div>
              </div>
            </div>


            <div class="row mt-2 p-1">
              <div class="col-md-2"></div>
              <div class="col-md-4 col-6 p-2">
                <button class="btn btn-primary w-100" (click)="navigateResetPassword()"><i class="fe-lock mr-1"></i>Reset Password</button>
              </div>
              <div class="col-md-4 col-6 p-2">
                <button class="btn btn-primary w-100" (click)="save()"><i class="fe-save mr-1"></i>Save</button>
              </div>
              <div class="col-md-2"></div>
            </div>
          </form>
        </div>
      </div>
    </div>




  </div> <!-- end container -->
</div>
